import script from "./StatisticsComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatisticsComp.vue?vue&type=script&setup=true&lang=ts"

import "./StatisticsComp.vue?vue&type=style&index=0&id=ede693ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ede693ac"]])

export default __exports__